import { render, staticRenderFns } from "./VboxList.vue?vue&type=template&id=b511ce7a&"
import script from "./VboxList.vue?vue&type=script&lang=js&"
export * from "./VboxList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports